module.exports = __webpack_public_path__ + "assets/images/4y4nwo8uFe.png";


//////////////////
// WEBPACK FOOTER
// ../assets/images/question1.png
// module id = 2188
// module chunks = 0